import PropTypes from "prop-types"

function DisplayPositionName({ id, ticker, country }) {
  let name = id
  if (country && country !== "US") {
    name = `${ticker} ${country}`
  } else if (ticker) {
    name = ticker
  }

  return <div className="display-name">
    {name}
  </div>
}

DisplayPositionName.propTypes = {
  id: PropTypes.string.isRequired,
  ticker: PropTypes.string,
  country: PropTypes.string,
}

export default DisplayPositionName
